import { Select } from "@/common/components/selectInput";
import { ILargeCardProps, LargeCard } from "../../stats/subs/LargeCard";
import {
  accountantFinancialsCards,
  accountantFinancialsTableHeaders,
  accountantFinancialsTableKeys,
  getAccountantFinancialsTableData,
} from "../data";
import { AccountantFinancialsWrapper } from "../style";
import { Button } from "@/common/components/button";
import Table from "@/common/components/Table";
import useQuery from "@/hooks/useQuery";
import {
  FINANCIAL_REPORT_URL,
  REPORT_MONITORING_URL,
} from "@/common/constants";
import { useCallback, useMemo, useState } from "react";
import { KeyValueObj } from "@/common/types";
import { useNavigate } from "react-router-dom";

const AccountantFinancials = () => {
  const [accountFinancialPerPage] = useState(10);
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentRow, setCurrentRow] = useState<KeyValueObj>({});
  const navigate = useNavigate();
  const {
    data: { data },
    loading: accountFinancialLoading,
  } = useQuery(
    FINANCIAL_REPORT_URL +
      `/sales-performance?per_page=${accountFinancialPerPage}&page=${accountFinancialPerPage}`
  );

  const { data: drfStats } = useQuery(REPORT_MONITORING_URL + `/stats-count`);

  const accountFinancialDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};
      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleViewFinancials = () => {
    navigate("month-sale");
  };

  const accountFinancialDropdownOptions = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleViewFinancials }]
        : [{ label: "View", action: handleViewFinancials }],
    [handleViewFinancials, currentRow]
  );

  return (
    <AccountantFinancialsWrapper>
      <div className="card-wrapper">
        {accountantFinancialsCards(drfStats)?.map((card: ILargeCardProps) => (
          <LargeCard
            color={card.color}
            icon={card.icon}
            value={card.value}
            title={card.title}
          />
        ))}
      </div>
      <div className="export-wrapper">
        <div className="select-wrapper">
          <Select
            name="Sort"
            formValues={[]}
            shortWidth
            fullWidth={false}
            placeholder="Sort By"
            prompt=""
            indexLevel={0}
            setFormValues={() => {}}
            options={[
              {
                title: "2025",
                value: "2025",
              },
              {
                title: "2024",
                value: "2024",
              },
            ]}
          />
        </div>
        <Button>Export</Button>
      </div>
      <div className="table-wrapper">
        <Table
          tableHeaders={accountantFinancialsTableHeaders}
          tableKeys={accountantFinancialsTableKeys}
          tableData={getAccountantFinancialsTableData(data)}
          tableTitle="Financial Report"
          loading={accountFinancialLoading}
          handleDropDownClicked={accountFinancialDropdownClick}
          showDropDown={showDropdown}
          dropDownOptions={accountFinancialDropdownOptions}
          spaced
          rowLineColor="light"
        />
      </div>
    </AccountantFinancialsWrapper>
  );
};

export default AccountantFinancials;
